import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import ItemForm from './itemForm'
import DateValidItemForm from './dateValidItemForm'
import NavPropertyItemForm from './navPropertyItemForm'
import RegexItemForm from './regexItemForm'
import HasRequiredValidToItemForm from './hasRequiredValidToItemForm'
import HasPersonStatusTypeItemForm from './hasPersonStatusTypeItemForm'
import NationalIdFormatItemForm from '@/components/codeLists/nationalIdFormatItemForm'
import CompanyClassItemForm from '@/components/codeLists/companyClassItemForm'

const propTypes = {
  itemType: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  item: PropTypes.object,
  navigationEntities: PropTypes.array
}

export const ItemEditorPicker = function (props) {
  const isReadOnly = (!props.item ? false : props.item.isReadOnly) || props.disabled
  const handleChange = useCallback(props.onChange, [props])

  let validFromItem = props.item
  if (!validFromItem) {
    validFromItem = { ...props.item, validFrom: new Date() }
  }

  switch (props.itemType) {
    case 'AddressType':
    case 'BankType':
    case 'BanType':
    case 'CourseType':
    case 'EducationType':
    case 'JobPosition':
    case 'LicenseType':
    case 'OrganizationalUnitType':
    case 'PropertyType':
    case 'RelatedPersonType':
    case 'MessageState':
    case 'RecipientType':
    case 'BranchType':
    case 'ResponsibilityType':
    case 'OwnershipType':
    case 'Country':
    case 'IncorporationState':
    case 'DocumentType':
    case 'Blacklist':
    case 'PenaltySource':
    case 'BankState':
    case 'CompanyState':
    case 'Region':
    case 'Province':
    case 'BankCapitalOperationType':
    case 'ResidentialUnitType':
    case 'ExperienceType':
    case 'MembershipType':
    case 'DegreeOfMembership': {
      return (
        <DateValidItemForm item={validFromItem} isReadOnly={isReadOnly}
          onChange={handleChange} />
      )
    }
    case 'CompanyType':
      return (
        <NationalIdFormatItemForm item={validFromItem} isReadOnly={isReadOnly} onChange={handleChange} />
      )
    case 'CompanyClass':
      return (
        <CompanyClassItemForm item={validFromItem} isReadOnly={isReadOnly} onChange={handleChange} />
      )
    case 'Township':
    case 'District':
    case 'CompanySubtype': {
      return (
        <NavPropertyItemForm item={validFromItem} isReadOnly={isReadOnly}
          navigationEntities={props.navigationEntities}
          onChange={handleChange} />
      )
    }
    case 'ContactInformationType': {
      return (
        <RegexItemForm item={validFromItem} isReadOnly={isReadOnly}
          onChange={handleChange} />
      )
    }
    case 'PersonalIdType':
      return (
        <HasRequiredValidToItemForm
          item={validFromItem}
          isReadOnly={isReadOnly}
          onChange={handleChange} />
      )
    case 'PersonStatus':
      return (
        <HasPersonStatusTypeItemForm
          item={validFromItem}
          isReadOnly={isReadOnly}
          onChange={handleChange} />
      )
    default: {
      return (
        <ItemForm item={props.item} isReadOnly={isReadOnly}
          onChange={handleChange} />
      )
    }
  }
}

ItemEditorPicker.propTypes = propTypes



// WEBPACK FOOTER //
// ./src/components/codeLists/itemEditorPicker.js